<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Nagpur District Rapid & Blitz Chess Championship 2026 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>Nagpur District Rapid & Blitz Chess Championship 2026</span></h2>
        </div>
        <p><strong>Venue:</strong> GH Raisoni College, 11th Floor, Moot Court Hall, Riaan Tower, Mangalwari, Nagpur</p>
        <p><strong>Date:</strong> 01/03/2026</p>

        <p>The <strong>Nagpur District Rapid & Blitz Chess Championship 2026</strong> was successfully organized on
            <strong>01st March 2026</strong> at <strong>GH Raisoni College</strong>, 11th Floor, Moot Court Hall,
            Riaan Tower, Mangalwari, Nagpur.
        </p>

        <p>The championship was organized by <strong>Chess Association Nagpur</strong>, in association with
            <strong>GH Raisoni Sports and Cultural Foundation</strong> and <strong>Kalpana Prakash Welfare
                Foundation</strong>.
        </p>

        <p>The event was conducted as a mixed tournament in which boys and girls competed together, while prizes
            were awarded separately for each age category.</p>
        <hr>
        <h5 class="primary-purple">Prize Money & Selection Details</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Cash Prize:</strong> ₹5,000 per category</li>
            <li><strong>Total Cash Prize Fund:</strong> ₹10,000</li>
            <li>Cash Prizes Top 5 & Trophies for Top 10</li>
            <li>Medals for Top 3 – S55, U19, U15, U11, U13, U-09 & U-07 (Boys & Girls separately)</li>
            <li><strong>Selection Criteria:</strong> <strong>Top 2 players from each category</strong> (Boys & Girls)
                were selected to represent <strong>State Level</strong> in the next stage of the championship.</li>
            <li>Total Number of Participants:
                <ul class="list-style list-style1 mb-3 list-count">
                    <li>Rapid :- 145 Participants</li>
                    <li>Blitz :- 101 Participants</li>
                </ul>
            </li>
        </ul>
        <hr>
        <h5 class="primary-purple">Dignitaries Present:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Shri Shekhar Suryawanshi</strong>, Superintendent, Central GST, An Ace Athlete and Coach</li>
            <li><strong>Shri Bhushan Shriwas</strong>, Secretary Kalpana Prakash Welfare Foundation & Chess Association
                Nagpur</li>
            <li><strong>Shri S.S Soman</strong>, Working President CAN</li>
            <li>IA Shiva Iyer, Chief Arbiter</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Tournament Highlights:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Format:</strong> Blitz, 8 Rounds, Swiss System</li>
            <li><strong>Time Control:</strong> 03 mins + 02 sec increment per move</li>
            <li><strong>Format:</strong> Rapid, 8 Rounds, Swiss System</li>
            <li><strong>Time Control:</strong> 10 mins + 05 sec increment per move</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Arbiter Team:</h5>
        <ul class="list-style list-style1 mb-3 list-count">
            <li><strong>Arbiter Team Lead by:</strong> IA Shiva Iyer (Chief Arbiter)</li>
            <li><strong>Deputy & Supporting Arbiters:</strong></li>
            <li>FA Amitkumar, Mukesh Tembhurne (Deputy Chief Arbiter)</li>
            <li>SNA Shrikant, Bagde</li>
            <li>SNA Shishir Indurkar</li>
            <li>SNA Prayas Ambade</li>
        </ul>
        <hr>
        <h5 class="primary-purple">Final Standing (Blitz)</h5>
        <div class="col">
            <p><strong>Final Standing (Blitz):</strong></p>
            <ul class="mb-3">
                <li>1. Vishwaditya Awasthi (Blitz Winner)</li>
                <li>2. Sharma Sai (Blitz Runner-Up)</li>
            </ul>
        </div>

        <div class="col">
            <p><strong>Final Standing (Rapid):</strong></p>
            <ul class="mb-3">
                <li>1. Ambone Shourya (Open)</li>
                <li>2. Gupta Pratham Arpit (Open)</li>
            </ul>
        </div>
        <hr>

        <p>A group winner photo of the <strong>Nagpur District Rapid & Blitz Chess Championship 2026</strong> was taken
            and preserved as a special memory of the event's successful completion.</p>
        <p>The tournament was conducted smoothly, adhering to FIDE and AICF regulations.
            The response from players was overwhelming, and feedback has been highly
            positive. The Chief Arbiter appreciates the cooperation from the organizers, support
            staff, and the fair play spirit exhibited by all participants.
        </p>
        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-2 row-cols-md-3">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-blitz-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Reports</h4>
                    </div>
                </div>
            </div>
            <div class="row row-cols-1 row-cols-lg-4">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/tournament-report.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Tournament Report </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/tournament-report-2.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Tournament Report 2 </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/blitz-prize-list.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Blitz Prize List </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-%26-blitz-open.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Rapid & Blitz Open </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/rapid-prize-list.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Rapid Prize List </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/signature-sheet-1.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Signature Sheet </h4>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nagpur-district/under-13.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title"><span class="flaticon-pdf"></span>
                                <h4> Under-13 </h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</section>
